const initialState = {
    pending: false,
    alertRules: [],
    page: 0,
    itemsCount: 0,
    pageCount: 0,
    error: null,
    filters: {active: 'ALL', itemsPerPage: 3, search: ''},
    selected: {}
};

const alertRulesReducer = (state = initialState, action) => {
    switch(action.type) {
        case 'GET_ALERT_RULES_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_ALERT_RULES_SUCCESS':
            return {
                ...state,
                pending: false,
                alertRules: action.alertRules,
                page: action.page,
                pageCount: action.pageCount,
                itemsCount: action.itemsCount
            };
        case 'GET_ALERT_RULES_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'GET_ALERT_MESSAGES_SUCCESS':
            return {
                ...state,
                pending: false,
                alertMessages: action.alertMessages
            }
        case 'GET_ALERT_MESSAGES_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'GET_ALERT_MEASUREMENT_TYPES_SUCCESS':
            return {
                ...state,
                pending: false,
                alertMeasurementTypes: action.alertMeasurementTypes
            }
        case 'GET_ALERT_MEASUREMENT_TYPES_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'SELECT_ALERT_RULE':
            return {
                ...state,
                selected: action.selected
            };
        case 'ADD_ALERT_RULE_SUCCESS':
            return {
                ...state,
                pending: false
            };
        case 'ADD_ALERT_RULE_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        default:
            return state;
    }
}

export default alertRulesReducer
